import axios from 'axios'
import qs from 'qs'

const state = () => ({
  loaded: false,
  dealers: [],
  dealersAll: [],
  loadedAllOnce: false,
  currentPage: 1,
  itemsPerPage: 8, // 8
  numberOfPages: 1,
  numberOfTotalDealers: 0
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {
      currentPage: state.currentPage,
      itemsPerPage: state.itemsPerPage
    }
    if (rootState.attribute.filterCategories.length) {
      params.attributes = {
        contains: rootState.attribute.filterCategories.toString()
      }
    }
    if (rootState.latitude && rootState.longitude) {
      params.lat = {
        equals: rootState.latitude
      }
      params.lng = {
        equals: rootState.longitude
      }
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setDealers (state, payload) {
    state.dealers = payload
  },
  addDealers (state, payload) {
    state.dealers = [...state.dealers, ...payload]
  },
  setDealersAll (state, payload) {
    state.dealersAll = payload
  },
  setLoadedAllOnce (state, payload) {
    state.loadedAllOnce = payload
  },
  resetCurrentPage (state) {
    state.currentPage = 1
    state.dealers = []
  },
  increaseCurrentPage (state) {
    state.currentPage += 1
  },
  setNumberOfPages (state, payload) {
    state.numberOfPages = payload
  },
  setNumberOfTotalDealers (state, payload) {
    state.numberOfTotalDealers = payload
  }
}

const actions = {
  async get ({ commit, getters, state }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.dealersearch_list.api_base + 'dealer-dealers/?' + qs.stringify(getters.getParams))
      state.currentPage === 1
        ? commit('setDealers', response.data.dealers)
        : commit('addDealers', response.data.dealers)
      commit('setNumberOfPages', response.data.numberOfPages)
      commit('setNumberOfTotalDealers', response.data.numberOfTotalItems)
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  },
  async increasePage ({ commit }) {
    commit('increaseCurrentPage')
  },
  async getAllOnceForMap ({ state, commit, getters }) {
    if (state.loadedAllOnce) return

    const all = []
    let page = 1
    const perPage = 300

    while (true) {
      const base = getters.getParams
      const params = { ...base, currentPage: page, itemsPerPage: perPage }
      const url = window.app.dealersearch_list.api_base + 'dealer-dealers/?' + qs.stringify(params)
      const res = await axios.get(url)
      const items = res.data?.dealers ?? []
      all.push(...items)

      const totalPages = res.data?.numberOfPages ?? page
      if (page >= totalPages || items.length === 0) break
      page++
    }

    commit('setDealersAll', all)
    commit('setLoadedAllOnce', true)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
